import { render, staticRenderFns } from "./DownloadComparisonTable.vue?vue&type=template&id=e0d4742a"
import script from "./DownloadComparisonTable.vue?vue&type=script&lang=js"
export * from "./DownloadComparisonTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports